import i18n from 'i18next'
import { DEFAULT_LANGUAGE } from 'constants/translations'

// EN - Directory-based imports
import commonEn from './locales/en/common.json'
import landingEn from './locales/en/landing.json'
import gameplayEn from './locales/en/gameplay.json'
import tutorialEn from './locales/en/tutorial.json'

// TR - Directory-based imports
import commonTr from './locales/tr/common.json'
import landingTr from './locales/tr/landing.json'
import gameplayTr from './locales/tr/gameplay.json'
import tutorialTr from './locales/tr/tutorial.json'

// CN - Directory-based imports
import commonCn from './locales/cn/common.json'
import landingCn from './locales/cn/landing.json'
import gameplayCn from './locales/cn/gameplay.json'
import tutorialCn from './locales/cn/tutorial.json'

const options = {
  interpolation: {
    escapeValue: false
  },

  debug: false,

  resources: {
    en: {
      common: {
        ...commonEn,
        ...landingEn,
        ...gameplayEn
      },
      tutorial: tutorialEn.tutorial
    },
    tr: {
      common: {
        ...commonTr,
        ...landingTr,
        ...gameplayTr
      },
      tutorial: tutorialTr.tutorial
    },
    cn: {
      common: {
        ...commonCn,
        ...landingCn,
        ...gameplayCn
      },
      tutorial: tutorialCn.tutorial
    }
  },

  fallbackLng: DEFAULT_LANGUAGE,

  ns: ['common', 'tutorial'],

  defaultNS: 'common',

  react: {
    wait: false,
    bindI18n: 'languageChanged loaded',
    bindStore: 'added removed',
    nsMode: 'default'
  }
}

const CustomLanguageDetector = {
  type: 'languageDetector',
  async: true,
  detect: (callback) => {
    callback(DEFAULT_LANGUAGE)
  },
  init: () => {},
  cacheUserLanguage: () => {}
}

i18n.use(CustomLanguageDetector).init(options)

export default i18n
